export const promote = (config) => ({
    ...config,
    connectionMode: config.webhookConnectionId ? 'connection' : 'custom'
});
//# sourceMappingURL=webhook-webhook-5-to-6.js.map